<tt-page *ngIf="!!edit">
    <tt-page-heading *ngIf="!!edit.webpage_heading" [ttModel]="edit.webpage_heading"></tt-page-heading>

    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="prod_id" [(ttModel)]="edit.prod_id"></tt-input>
        <tt-input-number ttLabel="new_discount" [(ttModel)]="edit.new_discount" ttTextAlign="right" ttFormatNumber ttDecimals="2"></tt-input-number>
        <tt-checkbox ttLabel="set_new_price" [(ttModel)]="edit.set_new_price"></tt-checkbox>
        <tt-input-number [hidden]="edit.set_new_price !== '1'" ttLabel="new_price" [(ttModel)]="edit.new_price" ttTextAlign="right" ttFormatNumber ttDecimals="2"></tt-input-number>
        <tt-button-save ttText="orderheadsetdisc_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
